/**
 * Полоса для перехода наверх страницы 
 * Расположена вдоль правой границы страницы, занимая часть экрана свободную от контента.
 * Кликабельная область полосы может быть меньше полосы по ширине и показывается при hover на полосе
 */
class PageUpBar {

  /**
   * 
   * @param {Object} options 
   * @param {String} options.bar Селектор полосы
   * @param {String} options.contentContainer Селектор контейнера содержимого страницы
   * @param {Number} options.barMinWidth Минимально возможная ширина полосы
   */
  constructor(options) {
    this.contentContainer = document.querySelector(options.contentContainer);
    this.bar = document.querySelector(options.bar);
    this.barLink = this.bar.firstElementChild;
    this.barMinWidth = options.barMinWidth;
    this.handleWindowScroll = this.handleWindowRisize =  this.update.bind(this);
    
    // устанавливает обработчик перехода наверх страницы при клике по полосе
    this.barLink.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo(0, 0);
    });
    window.addEventListener('scroll', this.handleWindowScroll);    
    // переинициализируем полосу при изменении размеров окна
    window.addEventListener('resize', this.handleWindowResize);    
    this.update();
  }

  /**
   * Определяет необходимость показа и расчитывает ширину полосы
   */
  update() {
    const contentWidth = this.getContentWidth(),
          // windowWidth = document.documentElement.clientWidth,
          windowWidth = window.innerWidth, // это со скролбаром
          barWidth = (windowWidth - contentWidth) / 2;

    // показывается, если пользователь не находится наверху страницы
    // и достаточно свободного места на экране справа
    if ((window.pageYOffset > 300) && (barWidth > this.barMinWidth)) {
      this.setWidth(barWidth);
      this.show();
    }
    else {
      this.hide();
    }
  }

  /**
   * Hides element
   */
  hide() {
    this.bar.classList.remove('page-up-bar--visible');    
  }

  /**
   * Shows element
   */
  show() {
    this.bar.classList.add('page-up-bar--visible');
  }

  /**
   * Устанавливает ширину полосы на заданную
   * @param {Number} value 
   */
  setWidth(value) {
    this.bar.style.width = value + 'px';
  }

  /**
   * Возвращает ширину контейнера с содержимым страницы
   */
  getContentWidth() {
    const box = this.contentContainer.getBoundingClientRect(); 
    return box.width || (box.right - box.left);
  }

}

export default PageUpBar;